// API Configuration
// Always use relative paths - the entire application runs on the same server/URL
export const API_BASE_URL = "/api";
export const BASE_URL = API_BASE_URL;
